import React, { useState, useEffect } from "react";
import axios from "axios";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

import { BrandingProvider, defaultBranding } from "./context/Branding";
import { getBackendUrl } from "./config";
import openSocket from "./services/socket-io";

const brandingKeys = [
  "brandName",
  "brandLogo",
  "brandLogoFit",
  "brandLogoPositionX",
  "brandLogoPositionY",
  "brandLogoScale",
  "companyFantasyName",
  "companyLegalName",
  "companyCnpj",
  "companyAddress",
  "companyPhone",
  "companyEmail",
  "companyWebsite"
];

/*
 * O tema do sistema vive em `context/DarkMode` (design tokens em
 * `theme/tokens.js`) e e aplicado dentro de `<Routes />`. Este
 * componente cuida apenas do branding vindo do backend.
 */
const App = () => {
  const [branding, setBranding] = useState(defaultBranding);

  useEffect(() => {
    const loadBranding = async () => {
      try {
        const { data } = await axios.get(`${getBackendUrl() || "http://localhost:8085"}/public-settings`);
        const nextBranding = { ...branding };
        data.forEach(setting => {
          nextBranding[setting.key] = setting.value;
        });
        setBranding(nextBranding);
      } catch (err) {
        // Keep default branding if the backend is still starting.
      }
    };

    loadBranding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const socket = openSocket();

    socket.on("settings", data => {
      if (data.action === "update" && brandingKeys.includes(data.setting?.key)) {
        setBranding(prev => ({
          ...prev,
          [data.setting.key]: data.setting.value
        }));
      }
    });

    return () => socket.disconnect();
  }, []);

  return (
    <BrandingProvider value={branding}>
      <Routes />
    </BrandingProvider>
  );
};

export default App;
